<template>
  <div class="chapter">
    <div class="chapter-wrapper">
      <div class="zlxc-container" style="overflow: visible">
        <div class="bread-crumbs">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>题库练习</el-breadcrumb-item>
            <el-breadcrumb-item>专项练习</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="chapter-choice">
          <div class="choice-title">
            {{ stepType == 1 ? "科目一" : "科目四" }} 专项练习
          </div>
          <div
            class="choice-list"
            v-if="chapterDataList && chapterDataList.length > 0"
          >
            <div
              class="choice-li"
              v-for="(item, index) in chapterDataList"
              :key="item.id"
            >
              <p class="li-title">
                <span class="section">第{{ index + 1 }}项</span
                >{{ item.title }}
              </p>
              <ul class="li-question">
                <li class="question" @click="tapSequencePractise(item.id)">
                  <p class="que-circle"></p>
                  <p class="que-literal">顺序答题</p>
                </li>
                <li class="question" @click="tapRandomPractise(item.id)">
                  <p class="que-circle"></p>
                  <p class="que-literal">随机答题</p>
                </li>
              </ul>
            </div>
          </div>
          <el-empty :image-size="200" v-else></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTestCenterList } from "@/api/herbalMedicine";

export default {
  name: "SpecialPractice",
  data() {
    return {
      // 车型
      carType: "car",
      // 科目
      stepType: 1,
      // 专项练习列表
      chapterDataList: [
       
      ],
    };
  },
  computed: {},
  created() {
    this.carType =
      this.$route.query.carType == "trolley"
        ? "car"
        : this.$route.query.carType;
    this.stepType = this.$route.query.stepType == "branchOne" ? 1 : 4;

    this._getTestCenterList();
  },
  methods: {
        // 获取模拟考试题
    _getTestCenterList() {
      getTestCenterList({
        carType: this.carType,
        stepType: this.stepType,
      }).then((res) => {
        if (res.data.length > 0) {
          this.chapterDataList = res.data;
        }
      });
    },
      // id: 121,
      //     title: "安全常识",
      //     subject: 1,
      //     car_type: null,
      //     count: 565,



    // carType: "car,bus,truck,motorcycle"
    // id: 101
    // subject: 1
    // title: "扣分罚款题"
    // 触发顺序答题
    tapSequencePractise(page) {
      this.$router.push({
        name: "Practise",
        query: {
          carType: this.carType,
          stepType: this.stepType == 1 ? 'branchOne' : 'branchFour',
          isOrder: "order",
          exerciseType: "special",
          knowType: page,
        },
      });
    },
    // 触发随机答题
    tapRandomPractise(page) {
      this.$router.push({
        name: "Practise",
        query: {
          carType: this.carType,
          stepType: this.stepType == 1 ? 'branchOne' : 'branchFour',
          isOrder: "noorder",
          exerciseType: "special",
          knowType: page,
        },
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
